import { H2, H3, P } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import { useFormikContext } from 'formik';
import React, { useCallback } from 'react';

import { ACCORDION_ITEMS, FIELD_NAMES, SUGGESTED_DESTINATIONS } from '../../constants';
import {
  ContentWrapper,
  DestinationContainer,
  ServiceWrapper,
  StyledAccordionSection,
  StyledJourneyButton,
} from './styles';
import { ModalComponentProps } from '../../../../../../components/embedded-widget/components/step-input';

const DestinationSuggestions = ({ autoCompleteRef, setIsModalOpen }: ModalComponentProps) => {
  const { setFieldValue } = useFormikContext();

  const setPopularDestinationHandler = useCallback(
    async (destination) => {
      await setFieldValue(FIELD_NAMES.WHERE, destination.value);
      setFieldValue(FIELD_NAMES.DESTINATIONS, destination.code);
      autoCompleteRef?.current?.focus();
      setIsModalOpen?.(false);
    },
    [setFieldValue, autoCompleteRef, setIsModalOpen],
  );

  return (
    <ContentWrapper>
      <H2 looksLike="h5">Where are you travelling?</H2>
      <P>Select or search for the country where you will spend the most time.</P>
      <H3 looksLike="h6" variant="marginBottomSpacer11">
        Popular destinations
      </H3>
      <DestinationContainer>
        {map(
          (destination) => (
            <StyledJourneyButton key={destination.label} onClick={() => setPopularDestinationHandler(destination)}>
              {destination.label}
            </StyledJourneyButton>
          ),
          SUGGESTED_DESTINATIONS,
        )}
      </DestinationContainer>
      <H3 looksLike="h6" variant="marginBottomSpacer11">
        Destination FAQs
      </H3>
      <ServiceWrapper>
        <StyledAccordionSection
          minimalBorder
          spacerSize="None"
          items={ACCORDION_ITEMS}
          accordionId="destination-faqs"
        />
      </ServiceWrapper>
    </ContentWrapper>
  );
};

export default DestinationSuggestions;
